import Constants from '../../utils/constants';

export default class TransportCreateRequest {
    constructor(locale, supportedLocales) {
        this.translations = [];
        this.availabilityInStatistics = false;
        supportedLocales.forEach((element) => {
            this.translations[element] = {
                name: '',
                phraseOfTraveledDistance: '',
                summaryText: '',
                summaryValueUnit: '',
                finalSummaryText: '',
                messageAfterSpeedLimitExceeded: '',
                messageKilometersPerCurrentTransportExceeded: '',
                messageKilometersPerMonthExceeded: '',
                messageKilometersPerDayExceeded: '',
                messageRadiusExceeded: '',
                messageNotValidStartPosition: '',
            };
        });
        this.latitude = Constants.initialLatitude;
        this.longitude = Constants.initialLongitude;
        this.met = null;
        this.mets = [];
        this.thresholdDistanceInKilometer = null;
        this.maximumRewards = null;
        this.steepness = null;
        this.localizationTolerance = null;
        this.transportToMoneyRatio = [];
        this.pointsPerKilometer = null;
    }

    static assign(from, to) {
        if (from) {
            to.locale = from.locale;
            to.name = from.name;
            to.phraseOfTraveledDistance = from.phraseOfTraveledDistance;
            to.availabilityInStatistics = from.availabilityInStatistics;
            to.summaryText = from.summaryText;
            to.mets = from.mets;
            to.summaryValueUnit = from.summaryValueUnit;
            to.maxKilometersPerMonth = from.maxKilometersPerMonth;
            to.maxKilometersPerDay = from.maxKilometersPerDay;
            to.maxKilometersPerCurrentTransport = from.maxKilometersPerCurrentTransport;
            to.finalSummaryText = from.finalSummaryText;
            to.messageAfterSpeedLimitExceeded = from.messageAfterSpeedLimitExceeded;
            to.messageKilometersPerCurrentTransportExceeded = from.messageKilometersPerCurrentTransportExceeded;
            to.messageKilometersPerMonthExceeded = from.messageKilometersPerMonthExceeded;
            to.messageKilometersPerDayExceeded = from.messageKilometersPerDayExceeded;
            to.messageRadiusExceeded = from.messageRadiusExceeded;
            to.messageNotValidStartPosition = from.messageNotValidStartPosition;
            to.met = from.met;
            to.latitude = from.latitude;
            to.longitude = from.longitude;
            to.localizationTolerance = from.localizationTolerance;
            to.thresholdDistanceInKilometer = from.thresholdDistanceInKilometer;
            to.maximumRewards = from.maximumRewards;
            to.steepness = from.steepness;
            to.pointsPerKilometer = from.pointsPerKilometer;
        } else {
            to = new TransportCreateRequest();
        }
    }

    static copy(from) {
        const to = new TransportCreateRequest();
        TransportCreateRequest.assign(from, to);
        return to;
    }
}
